<div class="employee-overview__dialog-box">
  <mm-dialog-title>
    <div class="employee-overview__dialog-header">
      <mm-icon [name]="'warning'" class="employee-overview__warning-icon"></mm-icon>
      <p class="employee-overview__dialog-title">
        {{ 'PAGES.AUTH.ASSISTED_SALES.ACCESS_ORDER_REVIEW.ACCESS_OVERVIEW' | translate }}
      </p>
    </div>
  </mm-dialog-title>

  <hr class="employee-overview__dialog-divider" />

  <mm-dialog-content>
    <p class="employee-overview__dialog-content">
      {{ 'PAGES.AUTH.ASSISTED_SALES.ACCESS_ORDER_REVIEW.NOTICE' | translate }}
    </p>
  </mm-dialog-content>

  <div class="employee-overview__dialog-footer">
    <button mm-button fluid="true" class="mm-button--secondary" (click)="handleResumeSession()">
      {{ 'PAGES.AUTH.ASSISTED_SALES.ACCESS_ORDER_REVIEW.RESUME_CURRENT_SESSION' | translate }}
    </button>
    <button mm-button fluid="true" class="mm-button--primary" (click)="handleOverviewClick()">
      {{ 'PAGES.AUTH.ASSISTED_SALES.ACCESS_ORDER_REVIEW.ACCESS_OVERVIEW' | translate }}
    </button>
  </div>
</div>
